import type { ReactNode } from "react";
import { useRef } from "react";
import classNames from "classnames";
import debounce from "lodash/debounce";
import { useDataTableDataProvider } from "../Provider/DataTableDataProvider";
import { useOnBottomReached } from "../hooks/useOnBottomReached";

export interface ScrollableContainerProps {
  children: ReactNode;
  className?: string;
}

export const ScrollableContainer = ({
  className,
  children,
}: ScrollableContainerProps) => {
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const { onBottomReached } = useDataTableDataProvider();

  const { fetchMoreOnBottomReached } = useOnBottomReached({
    tableContainerRef,
    onBottomReached,
  });

  const debouncedScroll = debounce(fetchMoreOnBottomReached, 500);

  return (
    <div
      onScroll={event => {
        debouncedScroll(event.target as HTMLDivElement);
      }}
      ref={tableContainerRef}
      className={classNames(className)}
    >
      {children}
    </div>
  );
};
